<script lang="ts">
import type { MenuProperties } from './menu.vue';
export interface FooterUrls {
  gradguard: string,
  members: string,
}
export interface FooterProperties {
  urls: FooterUrls,
  showMemberPortal?: boolean,
}
</script>
<script setup lang="ts">
const props = defineProps<FooterProperties>();

const products: MenuProperties[] = [
  {
    text: 'Renters Insurance',
    href: `${props.urls.gradguard}/renters`,
  },
  {
    text: 'Tuition Insurance',
    href: `${props.urls.gradguard}/tuition`,
  },
  {
    text: 'Auto Insurance',
    href: `${props.urls.gradguard}/auto-insurance`,
  },
  {
    text: 'Student Liability Insurance',
    href: `${props.urls.gradguard}/pro-liability`,
  },
  {
    text: 'International Student Resources',
    href: `${props.urls.gradguard}/international-students`,
  },
  {
    text: 'Travel Insurance',
    href: 'https://www.allianztravelinsurance.com/?utm_source=gradguard&utm_medium=referral&utm_campaign=homepage&utm_content=footer',
    target: '_blank',
  },
  {
    text: 'Student Legal Protection',
    href: 'https://collegeparents.org/student-protection',
    target: '_blank',
  },
];

const gradguard: MenuProperties[] = [
  {
    text: 'About Us',
    href: `${props.urls.gradguard}/about-us`,
  },
  {
    text: 'For Schools',
    href: 'https://hub.gradguard.com/',
    target: '_blank',
  },
  {
    text: 'Advisory Board',
    href: `${props.urls.gradguard}/advisory-board`,
  },
  {
    text: 'Press',
    href: `${props.urls.gradguard}/press`,
  },
  {
    text: 'Videos',
    href: `${props.urls.gradguard}/videos/library`,
  },
  {
    text: 'Careers',
    href: `${props.urls.gradguard}/careers`,
  },
];

const members = computed<MenuProperties[]>(() => {
  const menu: MenuProperties[] = [
    {
      text: 'Support',
      href: `${props.urls.gradguard}/support`,
    },
    {
      text: 'Contact Us',
      href: `${props.urls.gradguard}/contact`,
    },
  ];

  if (props.showMemberPortal) {
    menu.push({
      text: 'Member Portal',
      href: props.urls.members,
    });
  }

  menu.push({
    text: 'Student Blog',
    href: `${props.urls.gradguard}/blog`,
    target: '_blank',
  });
  return menu;
});


const legal: MenuProperties[] = [
  {
    text: 'Privacy Policy',
    href: `${props.urls.gradguard}/privacy-policy`,
  },
  {
    text: 'Terms of Use',
    href: `${props.urls.gradguard}/terms-of-use`,
  },
  {
    text: 'Licensing Info',
    href: `${props.urls.gradguard}/licensing-info`,
  },
  {
    text: 'Do Not Sell',
    href: `${props.urls.gradguard}/do-not-sell`,
  },
  {
    text: 'Disclaimers',
    href: `${props.urls.gradguard}/disclaimers`,
  },
  {
    text: 'Disclosures',
    href: `${props.urls.gradguard}/disclosures`,
  },
  {
    text: 'Accessibility',
    href: `${props.urls.gradguard}/accessibility`,
  },
];
</script>

<template>
  <footer class="bg-primary-800" aria-labelledby="footerHeading">
    <h2 id="footerHeading" class="sr-only">
      Footer
    </h2>
    <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
      <div class="xl:grid xl:grid-cols-3 xl:gap-8">
        <div class="flex justify-center md:grid md:grid-cols-2 xl:col-span-2 gap-8">
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <UiGradguardFooterMenu class="mt-10 sm:mt-0" title="Products" :menu="products" />
            <UiGradguardFooterMenu class="mt-10 sm:mt-0" title="Members" :menu="members" />
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <UiGradguardFooterMenu class="mt-10 sm:mt-0" title="GradGuard" :menu="gradguard" />
            <UiGradguardFooterMenu class="mt-10 sm:mt-0" title="Legal" :menu="legal" />
          </div>
        </div>
        <UiGradguardFooterRrss />
      </div>
      <slot name="message" />
      <div class="mt-8 border-t border-gray-500 pt-8">
        <p class="text-sm text-gray-300 md:mt-0 md:order-1 text-center">
          Copyright © 2009-{{ new Date().getFullYear() }} -
          GradGuard. All rights reserved. GradGuard is a service of
          <a href="https://nextgenins.com/" rel="noreferrer" class="underline">
            Next Generation Insurance Group, LLC</a> a Next Generation Insurance venture.
        </p>
      </div>
    </div>
  </footer>
</template>
